import * as React from 'react';
import {CardObject} from "../../../../types.d";
import {beautifyFalseAnswers, beautifyInfinitives} from "../../../../utils/falseAnswers";
import {VocabularyModal} from "../../../partials/modals/VocabularyModal";
import {ExerciseModal} from "../../../partials/modals/ExerciseModal";
import {useState} from "react";
import {ExplanationModal} from "../../../partials/modals/ExplanationModal";
import {Link} from "react-router-dom";

export interface ExerciseThumbProps {
    card: CardObject;
    canEdit?: boolean;
}

export const ExerciseThumb = (props: ExerciseThumbProps) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { card } = props;

    return <div className="card m-2 exercise-card-edit">
        <div className="card-header">
            <div className="mt-2"><h4>{ card.explanation.postTitle } { card.postTitle }</h4></div>
        </div>
        <div className="card-body">
            <p className="card-text text-left">
                <b>Exercise: </b>
                <span dangerouslySetInnerHTML={{ __html: card.explanationRules }} />
                <br />
                <b>False answers: </b>
                { beautifyFalseAnswers(card.falseAnswers) }
                <br />
                <b>Translation: </b>
                <span dangerouslySetInnerHTML={{ __html: card.exerciseTranslation }} />
                <br />
                <b>Infinitives only: </b>
                { beautifyInfinitives(card.infinitivesOnly) }
                <br />
                { card.reviewDescription && <i>Description: {card.reviewDescription}</i> }
            </p>
        </div>
        <div className="d-flex justify-content-between card-footer">
            <a href="" className="btn btn-sm btn-primary" onClick={e => {
                e.preventDefault();
                setModalVisible(true);
            }}>View Card Details</a>

            <EditableExerciseFooter canEdit={props.canEdit} card={card} />

            <ExerciseModal card={card} visible={modalVisible} toggle={() => setModalVisible(!modalVisible)}/>
        </div>
    </div>
};

export const EditableExerciseFooter = (props: { card: CardObject, canEdit: boolean }) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);

    return <>
        { props.canEdit && (
            <div>
                <Link to={`/lp/exercise/?card_id=${props.card.id}`} className="btn btn-sm btn-primary">Edit</Link>
            </div>
        ) }
        <div className={'mt-1'}>
            <h6><a href="" onClick={e => {
                e.preventDefault();
                setModalVisible(true);
            }}>Show Explanation Card</a></h6>
        </div>

        <ExplanationModal
            notEditable={!props.canEdit}
            card={props.card.explanation}
            visible={modalVisible}
            toggle={() => setModalVisible(!modalVisible)}/>
    </>
};
